export const CARD_PROGRAMS_PATH = "/admin/settings/card-programs";

export const cardProgramUploadPath = (
  connectionId: string,
  programId?: string,
) =>
  `/upload?connectionId=${connectionId}${programId ? `&programId=${programId}` : ""}`;
